import { Component, OnInit } from '@angular/core';
import { AppService } from '@app/app.service';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { OIDCService } from '@app/auth/services/oidc.service';
import { ToastService } from '@app/portal/services/toast-service';
import { RouterService } from '@app/routing/router.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';

@UntilDestroy()
@Component({
  selector: 'portal-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  standalone: false,
})
export class LoginPageComponent implements OnInit {
  public pageSubtitle: string;

  contentIsHidden = true;

  constructor(
    private appService: AppService,
    private authenticationService: AuthenticationService,
    private routerService: RouterService,
    private toastService: ToastService,
    private oidcService: OIDCService,
    private translateService: TranslateService
  ) {
    this.appService.branding.data$.pipe(untilDestroyed(this)).subscribe((branding) => {
      this.pageSubtitle = branding.pageSubtitle;
    });
  }

  ngOnInit() {
    this.appService.initialized$.pipe(untilDestroyed(this)).subscribe((initialized) => {
      if (initialized) {
        // in case of OIDC and the redirect back from keycloak to the login page
        // we want to hide the page content because internal redirect will be performed to a specific component
        this.oidcService.userAuthenticated$.pipe(untilDestroyed(this)).subscribe((authenticated) => {
          if (authenticated === false) {
            this.contentIsHidden = false;
          }
        });

        const oidcError: string | null = this.oidcService.oidcAuthenticationError();
        if (oidcError != null) {
          this.translateService
            .getStreamOnTranslationChange(oidcError)
            .pipe(untilDestroyed(this))
            .subscribe((translation) => {
              this.toastService.show({
                body: translation,
                hideOpenToasts: true,
                type: 'danger',
              });
            });
        }

        this.redirectIfAuthenticated();
      }
    });
  }

  /**
   * Checks if the user is authenticated and if so then it redirects to the initial page for the user
   *
   * @return Returns if the user was redirected
   */
  private redirectIfAuthenticated() {
    let redirected = false;

    if (this.authenticationService.isAuthenticated) {
      this.routerService.navigateToInitialRoute();

      redirected = true;
    }

    return redirected;
  }
}
